import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { SharedDataService } from '../../all-services';

@Component({
  selector: 'infos-demat',
  templateUrl: './infos-demat.component.html',
  styleUrls: ['./infos-demat.component.scss']
})
export class InfosDematComponent implements OnInit {

  @Output() closeWindow:EventEmitter<void> = new EventEmitter<void>();
  constructor(private sharedSvc:SharedDataService) { }

  ngOnInit(): void {
  }

  btnCloseClick():void{
    this.closeWindow.emit();
  }

  get lngCode():string{;
    return this.sharedSvc.lngCod || 'FR';
  }
}
